import ResultsSlice from "../../valueObjects/ResultsSlice.js";

/**
 * Checks whether scope of ResultsSlice is for pitcher
 * @param {ResultsSlice} slice 
 * @returns bool
 */
const resultsSliceForPitcher = function(slice) {
    return !!(slice instanceof ResultsSlice
        && slice.hasSubSlice()
        && !slice.scope.opponentId
        && !slice.scope.pitchType
        && slice.scope.tagId
        && !slice.scope.opponentTeamId
        && !slice.scope.opponentHandedness
        && !slice.scope.handedness
    );
};

export default resultsSliceForPitcher;